import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useState } from "react";
import { globalPostService, globalPutService } from "../../../../utils/globalApiServices";
import { addWetLeaseApi, updateWetLeaseApi } from "../apiService";
import { checkApiStatus } from "../../../../utils";
import { AttachementsUpload } from "../../../../shared_elements/components";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { formatBytes } from "../../../../utils/fileUpload";
import { backendDateFormat, fieldDateFormat } from "../../../../constants";
import { regexConstants } from "../../../../constants/regEx";
import LessMoreTextFieldComp from "../../../../shared_elements/components/LessMoreTextFieldComp";

const WetLeaseCRU = ({ params, modeType, addEditWetLease, fileUpload, onToggleModal,getResponseBack,onOpenAttachments }) => {
  const dispatch = useDispatch()
  const { storageDetails } = useSelector((state) => state.leases);
  const { enqueueSnackbar } = useSnackbar();
  const [addEditWetLeaseData, setAddEditWetLeaseData] = useState(addEditWetLease.data);
  const [error, setError] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const onAddEditWetLease = () => {
    let validationInputs = {}
    validationInputs = {
      name: addEditWetLeaseData?.name ? "" : "Please enter Name"
    }
    const startDate = moment(addEditWetLeaseData?.start_date);
    const endDate = moment(addEditWetLeaseData?.end_date);
    if (addEditWetLeaseData?.start_date && addEditWetLeaseData?.end_date) {
      if (endDate.isBefore(startDate)) {
        validationInputs.end_date = "End date cannot be before start date";
      }
      if (startDate.isAfter(endDate)) {
        validationInputs.start_date = "Start date cannot be after end date";
      }
    }
    if (addEditWetLeaseData?.start_date && !startDate.isValid()) {
      validationInputs.start_date = "Please enter valid Start Date";
    }
    if (addEditWetLeaseData?.end_date && !startDate.isValid()) {
      validationInputs.end_date = "Please enter valid End Date";
    }
    if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
      setLoading(true);
      if (addEditWetLeaseData.id) {
        globalPutService(updateWetLeaseApi({ leaseSlug:params?.leaseSlug, slug: addEditWetLeaseData.slug }), addEditWetLeaseData)
          .then(async(response)=>{
            if(checkApiStatus(response)){
          if (uploadedFiles?.length > 0) {
             fileUpload(addEditWetLeaseData.slug,'updated')
          }
          onToggleModal();
          getResponseBack();
          setLoading(false);
          enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
          trackActivity('Item Edited', { page_title: `Edit Wet Lease`, success_msg: response?.data?.message, item_id: addEditWetLeaseData?.id, payload: addEditWetLeaseData, response: response?.data })
        }
      else {
        setLoading(false);
        enqueueSnackbar(response.data.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
        trackActivity('Item Edited', { page_title: `Edit Wet Lease`, error_msg: response?.data?.message, item_id: addEditWetLeaseData?.id, payload: addEditWetLeaseData, response: response?.data })
      }
    })
  }
  else {
  globalPostService(addWetLeaseApi({ leaseSlug: params?.leaseSlug, }), addEditWetLeaseData).then(async (response) => {
    if(checkApiStatus(response)){
    if (uploadedFiles?.length > 0) {
        fileUpload(response?.data?.data.slug,'created')
    }
    onToggleModal();
    getResponseBack();
    setLoading(false);
    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
    trackActivity('Item Added', { page_title: `Add Wet Lease`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: addEditWetLeaseData, response: response?.data })
  }
      else {
      setLoading(false);
      enqueueSnackbar(response?.data?.message, { variant:"error", anchorOrigin: { horizontal:"right", vertical:"top"}, })
      trackActivity('Item Added', { page_title: `Add Wet Lease`, error_msg: response?.data?.message, item_id: null, payload: addEditWetLeaseData, response: response?.data })
    }
   } )
}
 } else {
      setError(validationInputs);
      trackActivity(`Item ${modeType === 'add' ? 'Added' : 'Edited'}`, { page_title: `${modeType === 'add' ? 'Add' : modeType === 'edit' ? 'Edit' : 'View'} Wet Lease`, error_msg: validationInputs, })
}
}
const handleFileChange=(files)=>{
  setUploadedFiles(files);
  dispatch(setFileUploadDetails({attachments:files}))
}

const onFieldChange = (key, value) => {
  setAddEditWetLeaseData({ ...addEditWetLeaseData, [key]: value });
};
const handleItemClicked = (page_type) => {
  trackActivity('Item Clicked', { page_title: `${ addEditWetLease.mode === "add" ? "Add" : addEditWetLease.mode === "edit" ? "Edit" : "View" } Wet Lease`, page_type: page_type, })
    }

  const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

return (
  <Box>
    <Dialog open={addEditWetLease.modal}
      className="add-lease-dialog"
      maxWidth="md"
      fullWidth >
      <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
        <Typography className="dialog-header-title">
          {addEditWetLease.mode === "add" ? "Add" : addEditWetLease.mode === "edit" ? "Edit" : "View"} Wet Lease
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid size={{ md: 4, xs: 12 }}>
            <TextField value={addEditWetLeaseData.name} disabled={modeType === "view"} required label="Name" variant="outlined" size="small" margin="normal" slotProps={{ inputLabel: { shrink: true },htmlInput: {maxLength: 255} }} fullWidth helperText={error.name} error={error.name}
              onChange={(e) => {
              regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("name", e.target.value.trimStart()) : e.preventDefault()
              setError({ ...error, name: "" })
              }} />
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                id="start date"
                value={addEditWetLeaseData?.start_date ? moment(addEditWetLeaseData?.start_date) : null}
                disabled={modeType === "view"} 
                label="Start Date"
                slotProps={{
                  popper: { placement: 'bottom-end' },
                  textField: {
                    InputLabelProps: { shrink: true },
                    size: "small",
                    margin: "normal",
                    error: error.start_date || false,
                    helperText: error.start_date || '',
                  },
                  field: {
                    clearable: true,
                    onClear: () => {
                      onFieldChange("start_date", null);
                      onRestErrorKey("start_date");
                    }
                  }
                }}
                sx={{ width: "100%" }}
                format={fieldDateFormat}
                onChange={(newDate) => {
                  const isValid = moment(newDate)?.isValid();
                  onFieldChange("start_date", newDate ? moment(newDate).format(backendDateFormat) : null)
                  if (isValid) {
                    onRestErrorKey("start_date");
                  }
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid size={{ md: 4, xs: 12 }}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                id="end_date"
                value={addEditWetLeaseData.end_date ? moment(addEditWetLeaseData.end_date) : null}
                disabled={modeType === "view"}
                label="End Date"
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    size: "small",
                    margin: "normal",
                    error: error.end_date || false,
                    helperText: error.end_date || '',
                  },
                  field: {
                    clearable: true,
                    onClear: () => {
                      onFieldChange("end_date", null);
                      onRestErrorKey("end_date");
                    }
                  }
                }}
                sx={{ width: "100%" }}
                format={fieldDateFormat}
                onChange={(newDate) => {
                  const isValid = moment(newDate)?.isValid();
                  const formattedDate = isValid ? moment(newDate).format(backendDateFormat) : null;
                  onFieldChange("end_date", newDate ? moment(newDate).format(backendDateFormat) : null)
                  if (isValid) {
                    onRestErrorKey("end_date");
                  }
                }}
                minDate={addEditWetLeaseData?.start_date ? moment(addEditWetLeaseData.start_date) : null}
              />
            </LocalizationProvider>
          </Grid>
          {modeType === 'view' ?
            <Grid item size={{ md: 12, xs: 12 }}>
              <LessMoreTextFieldComp label='Details' value={addEditWetLeaseData?.details || ""} />
            </Grid>
            : <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                value={addEditWetLeaseData?.details || ""}
                label="Details"
                variant="outlined"
                size="small"
                margin="normal"
                slotProps={{ inputLabel: { shrink: true } }}
                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                fullWidth
                multiline
                rows={3}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("details", e.target.value.trimStart()) : e.preventDefault()
                  setError(prev => ({ ...prev, details: "" }));
                }}
                />
            </Grid>}
          {modeType === 'view' ?
            <Grid item size={{ md: 12, xs: 12 }}>
              <LessMoreTextFieldComp label='Remarks' value={addEditWetLeaseData?.remarks || ""} />
            </Grid>
            : <Grid size={{ md: 12, xs: 12 }}>
              <TextField
                value={addEditWetLeaseData?.remarks || ""}
                label="Remarks"
                variant="outlined"
                size="small"
                margin="normal"
                slotProps={{ inputLabel: { shrink: true } }}
                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                fullWidth
                multiline
                rows={3}
                onChange={(e) => {
                  regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("remarks", e.target.value.trimStart()) : e.preventDefault()
                  setError(prev => ({ ...prev, remarks: "" }));
                }} />
            </Grid>}
          <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>
             <Box className="responsive-buttons" >

            {
              addEditWetLeaseData?.id && addEditWetLeaseData?.attachments?.length ?
                <Button onClick={()=>{onOpenAttachments();handleItemClicked('View Attachments')}} size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }} >
                {`${addEditWetLeaseData?.attachments?.length}: Attachments`}
              </Button>:null
            }
             <Button className="available-space-btn" disableRipple size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`Available Space : ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
            </Box>
           {modeType==='view'?null: <AttachementsUpload onFileChange={handleFileChange} attachments={addEditWetLeaseData?.attachments} remainingStorage={storageDetails?.remaining_storage}/>}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions className="dialog-action">
        <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{modeType === "view" ? "Close" : "Cancel"}</Button>
        {modeType === "view" ? null :
          <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onAddEditWetLease() }}>{isLoading ? <CircularProgress color="inherit" size={25} /> : "SAVE"}</Button>}
      </DialogActions>
    </Dialog>
  </Box>
)
}
export default WetLeaseCRU;